import { FC, useEffect } from "react";

declare global {
  interface Window {
    _paq?: Array<unknown>;
  }
}

const MatomoTracker: FC<{ siteId: string; matomoUrl: string }> = ({ siteId, matomoUrl }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.src = `${matomoUrl}/matomo.js`;
    document.body.appendChild(script);

    window._paq = window._paq || [];
    window._paq.push(["setDocumentTitle", "Page load"]);
    window._paq.push(["trackPageView"]);
    window._paq.push(["enableLinkTracking"]);
    window._paq.push(["setTrackerUrl", `${matomoUrl}/matomo.php`]);
    window._paq.push(["setSiteId", siteId]);
  }, [siteId, matomoUrl]);

  return null;
};

export { MatomoTracker };
